module.exports = "<ul class=\"AutocompletePredictions\" ng-style=\"css\">\n  <sa-location-search-prediction ng-repeat=\"prediction in ctrl.predictions\" prediction=\"prediction\"\n                                 ng-class=\"{ 'is-highlighted': $index === ctrl.selectedPrediction }\"\n                                 ng-mouseenter=\"ctrl.selectedPrediction = $index\"></sa-location-search-prediction>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/location_search/location_search_predictions.html
// module id = 311
// module chunks = 24